<template>
    <div style="position:relative;width:100%;overflow-x:hidden;">
        <nav class="agx-navbar-shop agx-theme-bg navbar navbar-fixed-top" style="z-index:100;">

            <div class="agx-navbar-wrapper" style="position:relative;" :style="{'margin-left':contentMarginLeft +'px'}">
                <slot name="topNavRight"></slot>
                <div>
                    <div class="navbar-header">

                        <button type="button" :style="{display:navIn?'none':'block'}" style="float: left;" class="navbar-toggle" @click="toggleNav">
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </button>

                        <slot name="topNavBrand"></slot>

                    </div>
                    <div class="agx-nav-bar navbar-collapse collapse">
                            <slot name="topNavMenus">

                            </slot>
                    </div>
                </div>

            </div>
        </nav>

        <nav @click="toggleNav" class="navbar sidebar agx-theme-bg" role="navigation"
             :style="{'margin-left':sideMenuMarginLeft +'px','width': menuWidth +'px' }" style="border-right: 1px solid gray; border-radius: 0px; position: fixed;height: 100%; float: left; z-index: 8000; margin-bottom: 0px; ">
            <div class="container-fluid" style="padding: 0 0px 0 0px;height:100%;overflow-y:auto;overflow-x:hidden;">
                <button type="button" style="float: left; display: block; height: 34px;" class="navbar-toggle">
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
               
                <!-- Collect the nav links, forms, and other content for toggling -->
                <div style="clear: both;">
                    <slot name="sideMenu"></slot>
                </div>

            </div>
        </nav>

        <div class="main" style="position:relative;">
            
            <div style="width:100%;background:white;padding-top:50px;position:relative;" :style="{'margin-left':contentMarginLeft +'px'}">
                <modal-relative :show="navIn" @clicked="toggleNav"></modal-relative>
                <div>
                    <slot name="topBody"></slot>
                </div>
                <div style="clear: both;margin:2px;"></div>
                <div :class="{'col-sm-4':showLeftCol}" style="min-height: 100%; border-right: 1px solid #ccc;">
                    <slot name="leftBody" v-if="showLeftCol"></slot>
                </div>
                <div :class="{'col-sm-8':showLeftCol}">
                    <slot name="body"></slot>
                </div>
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import Loading from '../base/Loading.vue';
    import ModalRelative from '../base/ModalRelative.vue';

    export default {
        components: {
            Loading: Loading,
            ModalRelative: ModalRelative
        },
        props: {

        },
        computed: {
            sideMenuMarginLeft: function () {
                return this.navIn === true ? 0 : -this.menuWidth;
            },
            contentMarginLeft: function () {
                return this.navIn === true ? this.menuWidth : 0;
            },
            isLargerThanSM: function () {
                return this.windowWidth > 768;
            },
            showLeftCol: function () {
                return this.isLargerThanSM && !this.isIndexPage;
            }
        },
        data: function () {
            return {
                menuWidth:250,
                navIn: false,
                windowWidth: window.innerWidth,
                isIndexPage: false
            }
        },
        methods: {
            toggleNav: function () {
                this.navIn = !this.navIn;
            },
            toggleMenu: function () {
                this.showMenu = !this.showMenu;
            },
            windowWidthUpdate: function () {
                this.windowWidth = window.innerWidth;
            },
            indexPageCheck: function () {
                this.isIndexPage = this.$router.currentRoute.name === 'index';
            }
        },
        created: function () {
            window.addEventListener('resize', this.windowWidthUpdate);
            this.indexPageCheck();
        },
        destroyed: function () {
            window.removeEventListener("resize", this.windowWidthUpdate);
        },
        watch: {
            '$route'() {
                this.indexPageCheck();
            }
        }
    }
</script>
